import {GET_OPERATION_STATE} from "@/store/action-types";
import {getDictionaryCombobox} from "@/api/common";

const SET_OPERATION_STATE = 'SET_OPERATION_STATE';

const state = {
  operationState: null,
};

const mutations = {
  [SET_OPERATION_STATE](state, data) {
    state.operationState = data;
  },
};

const actions = {
  // 获取运营状态
  [GET_OPERATION_STATE]({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      getDictionaryCombobox('OPERATION_STATE')
        .then((data) => {
          commit(SET_OPERATION_STATE, data || []);
          resolve();
        })
        .catch(() => reject());
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
